<template>
  <button
    class="boss-button-center pega-preview-jump-button hide-for-print"
    data-test="spPreview"
    @click="openSpPreview"
  >
    <img
      class="pega-icon-phone"
      src="@/assets/images/smartphone.png"
    >
    スマホ版プレビューはこちら
  </button>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    routeName: {
      type: String,
      required: true
    }
  },
  methods: {
    openSpPreview () {
      // ※遷移対象のparams変数には呼び出し元のparams変数が引き継がれるため指定は不要
      const routeData = this.$router.resolve({
        name: this.routeName
      })
      window.open(routeData.href, `window_sp_${this.id}`, 'width=394,height=667,scrollbars=1')
    }
  }
}
</script>
